import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import StyledTypography from '../../Common/StyledTypography';
import StyledBackButton from '../../Common/StyledBackButton';
import StyledDeleteButton from '../../Common/StyledDeleteButton';

interface ICancelBookingModalProps {
  handleDelete: () => void;
  handleDismiss: () => void;
  bookingName?: string;
  loading: boolean;
  loadingText: string;
}

function CancelBookingModal({
  handleDelete,
  handleDismiss,
  bookingName,
  loading,
  loadingText,
}: ICancelBookingModalProps) {
  const { t } = useTranslation();

  return (
    <Grid container flexDirection="column">
      <Grid
        item
        p="36px"
        gap="11px"
        display="flex"
        flexDirection="column"
        alignItems="center"
        sx={{
          background:
            'linear-gradient(175deg, rgba(255, 154, 154, 0.20) -9.81%, rgba(255, 88, 88, 0.20) 96.32%), #FFF',
        }}
        width="100%"
        borderRadius="10px 10px 0 0"
      >
        <img src="/assets/icons/trash-bin-large.svg" alt="bin" role="presentation" />
        <StyledTypography variant="bodyBold" textAlign="center">
          <span>
            {t('bookings.meeting')} {bookingName}
          </span>
        </StyledTypography>
      </Grid>

      <Grid item p="52px 32px 36px 32px" gap={6} display="flex" flexDirection="column">
        <Typography variant="h6" color="primary" textAlign="center">
          {t('bookings.cancelMeeting')}
        </Typography>
        <Box display="flex" gap="20px">
          {!loading && (
            <StyledBackButton variant="outlined" fullWidth onClick={handleDismiss}>
              <span>{t('clientTable.deleteClient.dismiss')}</span>
            </StyledBackButton>
          )}
          <StyledDeleteButton onClick={handleDelete} loading={loading} loadingText={loadingText}>
            {t('common.confirm')}
          </StyledDeleteButton>
        </Box>
      </Grid>
    </Grid>
  );
}

export default CancelBookingModal;
